import { useQuery } from 'react-query';
import { setupAxios } from '../axios/setupAxios';
import { Doctor } from '../pages/PatientWebForm/constants/stepsData';

const useSelectOptions = (key: any, getFunction: Function, mapper: Function, params?: any) => {
  return useQuery(
    key,
    () =>
      setupAxios(getFunction(params)).then(response => {
        const tempData: Array<Doctor> = response.data.map((item: any) => {
          return mapper(item);
        });
        return tempData;
      }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      cacheTime: 4543534543543,
    }
  );
};

export default useSelectOptions;
